export default {
	monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	abvMonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	customFormatter(date, format) {
		let fDate = new Date(date);

		if (format === 'dash') {
			return `${(fDate.getUTCMonth() + 1)}-${fDate.getUTCDate()}-${fDate.getUTCFullYear()}`;
		}
		else if (format === 'slash') {
			return `${(fDate.getUTCMonth() + 1)}/${fDate.getUTCDate()}/${fDate.getUTCFullYear()}`;
		}
		else {
			return `${(fDate.getUTCMonth() + 1)}/${fDate.getUTCDate()}/${fDate.getUTCFullYear()}`;
		}
	},
	formatDate(date) {
		let fDate = new Date(date);

		return `${this.monthNames[fDate.getUTCMonth()]} ${fDate.getUTCDate()}, ${fDate.getUTCFullYear()}`;
	},
	formatDateAbv(date) {
		let fDate = new Date(date);
		//let month = fDate.getUTCMonth() + 1;
		//if (month === 5) {
			return `${this.abvMonthNames[fDate.getUTCMonth()]} ${fDate.getUTCDate()}, ${fDate.getUTCFullYear()}`;
		//} else {
			//return `${this.abvMonthNames[fDate.getUTCMonth()]}. ${fDate.getUTCDate()}, ${fDate.getUTCFullYear()}`;
		//}
	},
	formatDay(date) {
		let fDate = new Date(date);

		return `${fDate.getUTCDate()}`;
	},
	formatMonth(date) {
		let fDate = new Date(date);

		return `${this.abvMonthNames[fDate.getUTCMonth()]}`;
	},
	formatDateStart(start) {
		let startDate = new Date(start);
		if (!start || start === '0001-01-01T00:00:00' || start.startsWith('0001-01-01') || startDate.getUTCFullYear() < 1990) {
			return '';
		}
		return `${this.monthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
	},
	formatDateStartAbv(start) {
		let startDate = new Date(start);
		let startMonth = startDate.getUTCMonth() + 1;
		if (!start || start === '0001-01-01T00:00:00' || start.startsWith('0001-01-01') || startDate.getUTCFullYear() < 1990) {
			return '';
		}
		if (startMonth === 5) {
			return `${this.abvMonthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
		} else if (startMonth === 9) {
			return `${this.abvMonthNames[startDate.getUTCMonth()]}t. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
		} else {
			return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
		}
	},
	formatDateRange(start, end) {
		let startDate = new Date(start);
		let endDate = new Date(end);
		if (startDate === '0001-01-01T00:00:00' || startDate.getUTCFullYear() < 1990) {
			return '';
		}
		if (end === '0001-01-01T00:00:00' || endDate.getUTCFullYear() <= 1 || startDate === endDate) {
			return `${this.monthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
		}
		else if (startDate.getUTCFullYear() === endDate.getUTCFullYear()) {
			if (startDate.getUTCMonth() === endDate.getUTCMonth()) {
				return `${this.monthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()} - ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
			else {
				return `${this.monthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()} - ${this.monthNames[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
		}
		else {
			if (end === '0001-01-01T00:00:00' || endDate.getUTCFullYear() <= 1) {
				return `${this.monthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
			}
			return `${this.monthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.monthNames[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
		}
	},
	formatDateRangeAbv(start, end) {
		let startDate = new Date(start);
		let endDate = new Date(end);
		let startMonth = startDate.getUTCMonth() + 1;
		let endMonth = endDate.getUTCMonth() + 1;
		if (startDate === '0001-01-01T00:00:00' || startDate.getUTCFullYear() < 1990) {
			return '';
		}
		if (end === '0001-01-01T00:00:00' || endDate.getUTCFullYear() <= 1 || startDate === endDate) {
			if (startMonth === 5) {
				return `${this.abvMonthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
			} else if (startMonth === 9) {
				return `${this.abvMonthNames[startDate.getUTCMonth()]}t. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
			} else {
				return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`;
			}
		}
		else if (startDate.getUTCFullYear() === endDate.getUTCFullYear()) {
			if (startDate.getUTCMonth() === endDate.getUTCMonth()) {
				if (startMonth === 5) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()} - ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
				} else if (startMonth === 9) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]}t. ${startDate.getUTCDate()} - ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
				} else {
					return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()} - ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
				}
			}
			else if (startMonth === 5) {
				return `${this.abvMonthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()} - ${this.abvMonthNames[endDate.getUTCMonth()]}. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
			else if (endMonth === 5) {
				return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()} - ${this.abvMonthNames[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
			else if (startMonth === 9) {
				return `${this.abvMonthNames[startDate.getUTCMonth()]}t. ${startDate.getUTCDate()} - ${this.abvMonthNames[endDate.getUTCMonth()]}. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
			else if (endMonth === 9) {
				return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()} - ${this.abvMonthNames[endDate.getUTCMonth()]}t. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
			else {
				return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()} - ${this.abvMonthNames[endDate.getUTCMonth()]}. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
		}
		else {
			if (end === '0001-01-01T00:00:00' || endDate.getUTCFullYear() <= 1) {
				return '';
			}
			if (startMonth === 5 && endMonth === 5) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			} else if (startMonth === 5 && endMonth === 9) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]}t. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			} else if (startMonth === 9 && endMonth === 5) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]}t. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			} else if (startMonth === 9 && endMonth === 9) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]}t. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]}t. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			} else if (startMonth !== 5 && endMonth === 5) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			} else if (startMonth === 5 && endMonth !== 5) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]}. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			} else if (startMonth !== 9 && endMonth === 9) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]}t. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			} else if (startMonth === 9 && endMonth !== 9) {
					return `${this.abvMonthNames[startDate.getUTCMonth()]}t. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]}. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
			}
			return `${this.abvMonthNames[startDate.getUTCMonth()]}. ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} - ${this.abvMonthNames[endDate.getUTCMonth()]}. ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`;
		}
	},
};